import { apiClient } from "../../../lib";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

export const riskDetailsApi = {
    fetchRiskDetail: async ({ riskId }: { riskId: string | null }): Promise<any> => {
        const response = await apiClient.get(`/risks/${riskId}`);
        return response.data;
    },
    fetchRiskSummary: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/summary' : `/risks/summary?project_id=${projectId}`);
        return response.data;
    },
    fetchCriticalRisks: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/critical-risk' : `/risks/critical-risk?project_id=${projectId}`);
        return response.data;
    },
    fetchRiskCategories: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/risk-categories' : `/risks/risk-categories?project_id=${projectId}`);
        return response.data;
    },
    fetchRiskMatrix: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/risk-matrix' : `/risks/risk-matrix?project_id=${projectId}`);
        return response.data;
    },
    fetchRiskRegister: async ({ projectId, searchKey, assignedToMe, quickFilters,status,category }: { projectId: string | undefined, searchKey?: string, assignedToMe?: boolean, quickFilters?: any, status?: string, category?: string ,worktypeGroup?: string,projectYear?: string }): Promise<any> => {
        const params = {
            project_id: projectId,
            search_term: searchKey,
            assign_to_me: assignedToMe,
            workstream_id: extractFilterValues(quickFilters?.workstream) || null,
            site_id: extractFilterValues(quickFilters?.site) || null,
            programme_id: extractFilterValues(quickFilters?.programme) || null,
            region_id: extractFilterValues(quickFilters?.region) || null,
            work_type_group_id: extractFilterValues(quickFilters?.['worktype-group']) || null,
            project_year: extractFilterValues(quickFilters?.projectYear) || null,
            status: status || null,
            category: category || null,
        };
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });

        
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/risks/risk-register?${queryString}`);
        return response.data;
    },
};